module.exports = __webpack_public_path__ + "static/img/3.ca78bf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/document/2/3.png
// module id = fD4q
// module chunks = 1